import { BrowserRouter } from 'react-router-dom';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $notificationStore, NotificationType } from '@lib/store';
import { Root } from '@routes';
import { ColorsEnum, Text } from '@shared/widgets';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-datepicker/dist/react-datepicker.css';

export const App = () => {
  const notification = useUnit($notificationStore.store);

  return (
    <BrowserRouter>
      {notification?.message && (
        <div
          className={clsx('w-dvw border bg-white dark:bg-soft-black fixed top-0 left-0 right-0 z-[50000]', {
            'border-red': notification.type === NotificationType.ERROR,
            'border-primary': notification.type === NotificationType.WARNING,
            'border-green': notification.type === NotificationType.SUCCESS,
          })}
        >
          <Text className='p-3 text-center' weight='semibold' color={getColor(notification.type)}>
            {notification.message}
          </Text>
        </div>
      )}
      <Root />
    </BrowserRouter>
  );
};

const getColor = (type: NotificationType) => {
  switch (type) {
    case NotificationType.ERROR:
      return ColorsEnum.Red;
    case NotificationType.WARNING:
      return ColorsEnum.Primary;
    case NotificationType.SUCCESS:
      return ColorsEnum.Green;
    default:
      return;
  }
};
